import { t } from "../../../hooks/useAppTranslation";
import {useEffect, useState} from 'react';

import {downloadBlobUrl} from '../helpers';
import {Image} from './Image';
import {Pdf} from './Pdf';
import {PreviewUnavailable} from './PreviewUnavailable';


export const File = ({fileId, fileType}) => {
  const [blobUrl, setBlobUrl] = useState(null);
  const [downloadingOn, setDownloadingOn] = useState(true);

  useEffect(() => {
    downloadBlobUrl(fileId)
        .then(blobUrl_ => {
          setBlobUrl(blobUrl_);
      setDownloadingOn(false);
    })
    .catch(() => setDownloadingOn(false));

    return () => {
      window.URL.revokeObjectURL(blobUrl);
    }
  }, []);

  if (downloadingOn) {
    return (
      <div className="image-preview">
        <p className="info-text" role="status">
          { t('g-downloading-file-preview') }
        </p>
      </div>
    )
  }

  if (!blobUrl) {
    return <PreviewUnavailable />
  }

  switch (fileType) {
    case 'image':
      return <Image blobUrl={blobUrl}/>;
    case 'pdf':
      return <Pdf blobUrl={blobUrl}/>;
    default:
      return <PreviewUnavailable/>
  }
};
